<template>
	<div id="profile" class="page">
		<div class="bm-list">
		  <div class='bm-li' v-on:click="addressPickerShow = true">
			  <div class='left'>选择地区<span style="color:red">*</span>：</div>
			  <div class='right'>
				   <input placeholder="请选择" :value="address | pickerValueFilter"/>
			  </div>
		  </div>
		  <div class='bm-li'>
			  <div class='left'>真实姓名<span style="color:red">*</span>：</div>
			  <div class='right'>
				   <input placeholder="请输入" v-model="name"/>
			  </div>
		  </div>
		  <div class='bm-li'>
			  <div class='left'>手机号码<span style="color:red">*</span>：</div>
			  <div class='right'>
				   <input placeholder="请输入" v-model="mobile"/>
			  </div>
		  </div>
		</div>
		<wv-picker
		  :visible.sync="addressPickerShow"
		  v-model="address"
		  ref="addressPicker"
		  :columns="addressColumns"
		  :visible-item-count="5"
		  @change="onAddressChange"
		  @confirm="confirmAddress"
		/>
		<van-button type="info" v-on:click="event_submit" style="width:96vw;margin:2vw auto;display:block;">保存</van-button>
	</div>
</template>

<script>
import chinaAreaData from 'china-area-data'
import { Toast } from 'we-vue'
const provinces = Object.values(chinaAreaData[86])
// 获取某一省下的市
const getCities = (province) => {
  let provinceCode
  for (let i in chinaAreaData[86]) {
    if (province === chinaAreaData[86][i]) {
      provinceCode = i
      break
    }
  }
  return typeof chinaAreaData[provinceCode] === 'object' ? Object.values(chinaAreaData[provinceCode]) : []
}
// 获取某一市下的区/县
function getAreas (province, city) {
  let provinceCode, cityCode
  for (let i in chinaAreaData[86]) {
    if (province === chinaAreaData[86][i]) {
      provinceCode = i
      break
    }
  }
  for (let i in chinaAreaData[provinceCode]) {
    if (city === chinaAreaData[provinceCode][i]) {
      cityCode = i
      break
    }
  }
  if (chinaAreaData[cityCode]) {
    return typeof chinaAreaData[cityCode] === 'object' ? Object.values(chinaAreaData[cityCode]) : []
  } else {
    // 只有两级的情况
    return []
  }
}
export default {
  data () {
    return {
		name:'',
		mobile:'',
      addressPickerShow: false,
      address: [],
      addressColumns: [
        {
          values: provinces
        },
        {
          values: getCities('云南省')
        },
        {
          values: getAreas('云南省', '昆明市')
        }
      ]
    }
  },
  mounted () {
		this.name = this.$store.state.userInfo.real_name
		this.mobile = this.$store.state.userInfo.mobile
		this.address = [this.$store.state.userInfo.region0 ? this.$store.state.userInfo.region0 : '云南省', this.$store.state.userInfo.region1 ? this.$store.state.userInfo.region1 : '昆明市',			this.$store.state.userInfo.region2 ? this.$store.state.userInfo.region2 : '五华区']
		this.$refs.addressPicker.setValues(this.address)
  },
  methods: {
    onAddressChange (picker, addressValues, slotIndex) {
      if (slotIndex === 0) {
        const cities = getCities(addressValues[0])
        picker.setColumnValues(1, cities)
        picker.setColumnValues(2, getAreas(addressValues[0], cities[0]))
      } else if (slotIndex === 1) {
        picker.setColumnValues(2, getAreas(addressValues[0], addressValues[1]))
      }
    },
    confirmAddress (picker) {
		this.address = picker.getValues()
    },
	event_submit(){
		if (!this.address[2]) {
			Toast.text({
			  duration: 1000,
			  message: '请选择您所在的地区'
			})
			return false;
		}

		if (!this.name) {
			Toast.text({
			  duration: 1000,
			  message: '请填写您的姓名'
			})
			return false;
		}

		if (!/(13|14|15|16|17|18)[0-9]{9}/.test(this.mobile)) {
			Toast.text({
			  duration: 1000,
			  message: '请输入正确的手机号码'
			})
			return false;
		}
		Toast.loading('laoding')
		this.$https.post('/api/user/settting',this.$qs.stringify({
			token:this.$store.state.token,
			name:this.name,
			region:JSON.stringify(this.address),
			mobile:this.mobile
		})).then((res) => {
			Toast.success({
				duration: 1000,
				message: '保存成功'
			})
			this.$store.state.userInfo.region0 = this.address[0]
			this.$store.state.userInfo.region1 = this.address[1]
			this.$store.state.userInfo.region2 = this.address[2]
			this.$store.state.userInfo.name = this.name
			this.$store.state.userInfo.mobile = this.mobile
		}).catch((res) => {});
	}
  },
  filters: {
    pickerValueFilter (val) {
      if (Array.isArray(val)) {
        return val.toString()
      } else {
        return '请选择'
      }
    }
  }
}
</script>

<style scoped>
	#wrong{
		background-color:#FFFFFF;
		min-height:100vh;
	}
	.hint{
  background: #fcfded;
  color: #f60;
  font-size: 4.38vw;
  padding: 3.5vw 3vw;
}
.bm-list{
  background: #fff;
  font-size:4.2vw;
}
.bm-li{
  border-bottom:1px solid #dedede;
  display: flex;
  justify-content: space-between;
  height:12vw;
  line-height:12vw;
}
.tiaokuan div{
  font-size:4.2vw;
}
.bm-li .left{
  padding-left:3vw;
  min-width:30vw;
}
.bm-li .right{
  padding-right:3vw;
}
.bm-li input{
  text-align: right;
  height:100%;
}
.baoming-info{
  padding: 3.13vw;
}
.tiaokuan{
  font-size: 4.69vw;
  display: flex;
  line-height: 7.5vw;
}
.bm-li input{
	font-size:4vw;
}
.tiaokuan span{
  color: #59c064;
}
.buy{
  margin-top: 10px;
  line-height: 7.5vw;
  color: #666;
  font-size: 3.69vw;
}
.fuwu{
  color: #59c064;
}
.pay{
  background:#5ddfff;
  color: #fff;
  margin-top: 10px;
  font-size: 4.69vw;
}
.tiaokuan .icon-circle .circle{
  width:6vw;
  margin-right:5px;
  display:inline-block;
  border-radius:100%;
  height:6vw;
  background-size:100%;
  border:2px solid #CCCCCC;
}
.tiaokuan .rightcircle{
  background:url(http://jk.ioccn.com/jiakao/rightcircle.png) no-repeat;
  width:9vw;
  margin-right:5px;
  display:inline-block;
  height:9vw;
  background-size:100%;
}
.tiaokuan .rightcircle .circle{
  display:none;
}
input{
	border:0px;display:block;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue